'use client';

import { useExposePageMountEffects } from '@/hooks/useExposePageMountEffects';

export const ExposePageMountEffects = () => {
  // TODO: this gets injected as react component in order to be properly placed inside the <ListingPageProviders> provider (https://engelvoelkers.atlassian.net/browse/NS-12539)
  // we can refactor this hook and actually move the internal logic in this component
  useExposePageMountEffects();
  return null;
};
